import React from 'react';
import s from './WallpaperGallery.css';
import getUser from '../../utils/getUser';
import withStyles from "isomorphic-style-loader/withStyles";
import short from 'short-uuid'
import Container from "@material-ui/core/Container";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import IconButton from "@material-ui/core/IconButton";
import { Info } from "@material-ui/icons";
import Grow from "@material-ui/core/Grow";
import CircularProgress from "@material-ui/core/CircularProgress";
import classNames from 'classnames';
import Button from "@material-ui/core/Button";
import Link from "../../components/Link";
import Typography from "@material-ui/core/Typography";

const shortUUID = short();

class WallpaperGallery extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            images: this.props.images,
            page: 1,
            hasMoreImages: true
        };
    }

    async onLoadMore() {
        let page = this.state.page + 1;
        this.setState({ loading: true });

        const images = await this.props.fetchPage(page);

        if (images && images.length) {
            this.setState({loading: false, images: this.state.images.concat(images), page: page });
        } else {
            this.setState({ loading: false, hasMoreImages: false, page: page });
        }
    }

    render() {
        const user = getUser();
        const { images, loading } = this.state;

        return (
            <div>
                <Container maxWidth="md">
                    <GridList cellHeight={300}>
                        {images.map(tile => (
                            <GridListTile key={tile.id} className={s.tile}>
                                <Link to={'/wallpaper/' + tile.id}>
                                <img src={tile.urlFull + '&height=350'} alt={tile.query} />
                                <GridListTileBar
                                    title={tile.query}
                                    subtitle={<span>by: {tile.authorName}</span>}
                                    actionIcon={
                                        <IconButton aria-label={`info about ${tile.authorName}`}>
                                            <Info />
                                        </IconButton>
                                    }
                                />
                                </Link>
                            </GridListTile>
                        ))}
                    </GridList>

                    {
                        (!images.length && !loading) &&

                        <Typography variant="h4" gutterBottom align="center">
                            Your gallery is empty
                        </Typography>
                    }

                    {loading && <div className={'placeholder'}>
                        <Grow in={loading} mountOnEnter unmountOnExit>
                            <CircularProgress/>
                        </Grow>
                    </div>}

                    {!loading && this.state.hasMoreImages &&
                    <div className={s.actionBtns}>
                        <Button
                            variant="contained"
                            color={'primary'}
                            onClick={this.onLoadMore.bind(this)}
                        >
                            LOAD MORE
                        </Button>
                    </div>}
                </Container>
            </div>
        );
    }
}

export default withStyles(s)(WallpaperGallery);